module.exports = __webpack_public_path__ + "static/img/goods-200.e6a8171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-200.png
// module id = ntVY
// module chunks = 2